export default interface Customer {
  id: string;
  fullName: string;
  firstName: string;
  lastName: string;
  email: string;
  date: string;
  investmentVehicle: string;
  refusedDate: string;
  evaluationDate: string;
  veriffResponse: any;
  optionsThatApply: string[];
  schedule: string;
  country: string;
  phone: string;
  relationships: Relationship[];
  relationship: string;
  scheduleDate: string;
  investorType: number;
  investorTypeDesc: string;
  howDoYouRank: string;
  classification: number;
  comment: string;
  refuseComment: string;
  status: number;
  statusDesc: string;
  scheduleIndexResponse: ScheduleIndexResponse;
  companyName:string;
  companyId: string;
  subscriptionStatus: string,
  lastAccess: string,
  appVersion: string,
  documents: string[];
  isAccountManager: boolean;
  hasLesteManagerRole: boolean;
  isAccountManagerOld: boolean;
  familyMembers: FamilyMembers[];
  oldFamilyMembers: FamilyMembers[];
  sentContracts: any[];
  notificationTypesEnable: any[];
  notificationSent: any;
  formsField: any[]
}

const customerInitValue: Customer = {
  id: String(),
  fullName: String(),
  firstName: String(),
  lastName: String(),
  email: String(),
  investmentVehicle: String(),
  veriffResponse: {},
  date: String(),
  refusedDate: String(),
  evaluationDate: String(),
  schedule: String(),
  country: String(),
  phone: String(),
  relationship: String(),
  scheduleDate: String(),
  investorType: Number(),
  investorTypeDesc: String(),
  howDoYouRank: String(),
  classification: Number(),
  comment: String(),
  refuseComment: String(),
  status: Number(),
  statusDesc: String(),
  companyId: String(),
  companyName: String(),
  subscriptionStatus: String(),
  appVersion: String(),
  lastAccess: String(),
  isAccountManager: Boolean(),
  isAccountManagerOld: Boolean(),
  hasLesteManagerRole: Boolean(),
  familyMembers: [],
  oldFamilyMembers: [],
  optionsThatApply:[],
  sentContracts: [],
  documents: [],
  relationships: [],
  scheduleIndexResponse: {
    cancelRescheduleLink: String(),
    creationTime: String(),
    durationMinutes: Number(),
    entryDate: String(),
    owner: String(),
    scheduleStatus: Number(),
    startingTime: String(),
    status: String(),
    subject: String(),
    bookingPage: {
      internalLabel: String(),
      link: String(),
      publicName: String(),
    },
  },
  notificationTypesEnable: [],
  notificationSent: {},
  formsField: []
};

export { customerInitValue }

interface Relationship {
  name: string;
  typeRelationship: number;
}

export interface FamilyMembers {
  email: string;
  userId: string;
  name: string;
}

interface ScheduleIndexResponse {
  cancelRescheduleLink: string;
  creationTime: string;
  durationMinutes: number;
  entryDate: string;
  owner: string;
  scheduleStatus: number;
  startingTime: string;
  status: string;
  subject: string;
  bookingPage: BookingPage;
}

interface BookingPage {
  internalLabel: string;
  link: string;
  publicName: string;
}
